"use strict"
export const wishlistButton = (productId, addLabel, removeLabel, isLoggedIn, isWished, toggleAction, thenRemove) => ({
    productId,
    addLabel,
    removeLabel,
    isLoggedIn,
    isWished,
    toggleAction,
    thenRemove,
    loading: false,
    async toggle() {
        this.loading = true;
        let response = await (await fetch(this.toggleAction)).json()
        if (response.success) {
            this.isWished = !this.isWished;
            if (!this.isWished && this.thenRemove) {
                this.$el.closest('li.product').remove();
            }
        }
        this.loading = false;
    },
    save() {
        localStorage.setItem('wishlist', JSON.stringify(this.wishList));
    }
});